import { apiGateway } from '../api';

async function getEnderecoByCep(cep) {
    try {
        const response = await apiGateway.get(`/busca/enderecos/${cep}`);
        return response.data;
    } catch (error) {
        return false;
    }
}

async function getEstados() {
    try {
        const response = await apiGateway.get('/enderecos/uf');
        return response.data;
    } catch (error) {
        return error;
    }
}

async function getMunicipios(siglaUf) {
    try {
        const response = await apiGateway.get(`/enderecos/uf/${siglaUf}/municipios`);

        return response.data;
    } catch (error) {
        return [];
    }
}

export { getEnderecoByCep, getEstados, getMunicipios };
